'use strict';

class BookingSuggestion {
  constructor($q, $http, userModel, utils) {
    this.$q = $q;
    this.$http = $http;
    this.userModel = userModel;
    this.utils = utils;
  }

  findAll(placeId, bookingId) {
    return new this.$q((resolve, reject) => {
      var config = {
        params: {
          placeId: placeId,
          bookingId: bookingId
        }
      };

      this.$http.get(this.utils.getApiUrl('guides/suggestions/' + String(this.userModel.item.id)), config)
        .then(function (response) {
          resolve(response.data.guides);
        })
        .catch(reject);
    });
  }
}

BookingSuggestion.$inject = [
  '$q',
  '$http',
  'userModel',
  'utils'
];

export default BookingSuggestion;



// WEBPACK FOOTER //
// ./app/src/resources/booking_suggestion.js